import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import type { Balance } from '../types'

interface BalanceState {
  total?: number
  isLoading: boolean
  error: string | null
}

const initialState: BalanceState = {
  isLoading: false,
  error: null,
}

const balanceSlice = createSlice({
  name: 'balance',
  initialState,
  reducers: {
    setBalance: (state, action: PayloadAction<Balance>) => {
      // const total = action.payload.da_user + action.payload.ga_user
      state.total = action.payload.points + action.payload.usd
      state.error = null
      state.isLoading = false
    },
    updateBalance: (state, action: PayloadAction<number>) => {
      state.total = action.payload
    },
    updateBalanceWithDiff: (state, action: PayloadAction<number>) => {
      state.total = Math.max(0, (state.total ?? 0) + action.payload)
    },
    clearBalance: (state) => {
      state.total = undefined
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
    setError: (state, action: PayloadAction<string>) => {
      state.error = action.payload
    },
  },
})

export const {
  setBalance,
  clearBalance,
  setLoading,
  setError,
  updateBalance,
  updateBalanceWithDiff,
} = balanceSlice.actions
export default balanceSlice
